<span class="cell-value">{{ displayValue }}</span>
<button
  *ngIf="isModified && !isSaving"
  type="button"
  mat-icon-button
  class="undo-overlay"
  matTooltip="Undo edit"
  aria-label="Undo edit"
  (click)="onUndoClick($event)"
>
  <mat-icon fontSet="material-symbols-outlined">undo</mat-icon>
</button>
